<template>


  <div id="deepzoomContent" class="imgContent">

  </div>
</template>

<script>
import OpenSeadragon from 'openseadragon'
// import {image_host} from "@/common/common";

export default {
  name: "DeepZoomSample",
  props: {
    detail: String,
  },
  data() {
    return {
      viewer: null,
      deepStatus:"",
      options: {
        id: "deepzoomContent",
        prefixUrl: "",
        tileSources: "",
        constrainDuringPan: true,
        showNavigator: false,
        showZoomControl: false,
        showHomeControl: false,
        showFullPageControl: false,

        navigatorAutoFade: false,
        navigatorOpacity: 0.5,
        showRotationControl: false
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      //as url like /dz/10001/FEF76773-48B7-465F-85B7-B49442B0BD53.dzi
      console.log("detail=",this.detail)
      if (this.isUndefined(this.detail)){
        this.loadByID()
      }else{
        let str=this.strTob(this.detail)
        let data=JSON.parse(str)
        this.options.tileSources="/dz/" + data.Artist.id + "/" + data.Product.imageid + ".dzi"
        this.viewer = OpenSeadragon(this.options)
      }


    },
    loadByID(){

     var aid = this.$route.query.id;
      var pid = this.$route.query.page;
      console.log("ZoomView aid=",aid)
      console.log("ZoomView pid=",pid)
      if (!this.isUndefined(aid) && !this.isUndefined(pid)){
        this.options.tileSources="/dz/" + aid + "/" + pid + ".dzi"
        this.viewer = OpenSeadragon(this.options)
      }

    },
    isUndefined(value) {
      if (value === undefined) {
        return true
      }
      if (value === null) {
        return true
      }

    },
// base64转字符串
   strTob(base64){
      // 对base64转编码
      var decode = atob(base64)
      // 编码转字符串
      var str = decodeURI(decode)
      return str
    }

  }
}
</script>

<style>
body{
  background-color: black;
}
.imgContent {
  position: absolute;
  width: 100%;
  height: 100%;
}

</style>
